import moment from "moment";
// import I18n from 'react-native-i18n';

let locale;

async function getLocale() {
   // locale = I18n.currentLocale();
   locale = "en_AU";
}

getLocale();

//pro lib has incorrect local for au
moment.locale("en_AU", {
   longDateFormat: {
      LT: "HH:mm",
      LTS: "HH:mm:ss",
      L: "DD/MM/YYYY",
      LL: "D MMMM YYYY",
      LLL: "D MMMM YYYY HH:mm",
      LLLL: "dddd D MMMM YYYY HH:mm"
   }
});

moment.locale(locale);

// Get locale data
const localeData = moment.localeData();
const format = localeData.longDateFormat("L");
const longDateFormat = localeData.longDateFormat("LL");
const dateTimeformat = localeData.longDateFormat("LLL");

const YEAR = 365 * 24 * 60 * 60 * 1000;
const MONTH = 30 * 24 * 60 * 60 * 1000;

export default class {
   static get localeFormat() {
      return format;
   }
   static get locale() {
      return locale;
   }

   static convertTimestamp(timestamp) {
      const date = moment.utc(timestamp);
      return date;
   }

   static age(timestamp) {
      if (timestamp) {
         const date = this.convertTimestamp(timestamp);
         const d = this.convertTimestamp(new Date()).diff(date, "y");
         return moment.localeData().relativeTime(d, false, d === 1 ? "y" : "yy");
      } else {
         return null;
      }
   }

   static parse(timestamp, formate = null, utc = false) {
      if (timestamp) {
         const date = utc ? this.convertTimestamp(timestamp) : moment(timestamp);
         return date.format(formate || format);
      } else {
         return null;
      }
   }

   static moment(timestamp) {
      return moment(timestamp);
   }

   static formatToLocale(date, inputFormat = undefined) {
      const frmt = moment(date, inputFormat);
      return frmt.format(format);
	}
	
	static dateAndTime(date){
		return moment.utc(date).format("DD MMM hh:mma")
	}

   static formatToLocaleLongDate(date, inputFormat = undefined) {
      const frmt = moment(date, inputFormat);
      return frmt.format(longDateFormat);
   }

   static stringToDate(str) {
      return moment(str, format).toDate();
   }

   static toISOstring(date) {
      return moment(date, format).toISOString();
   }

   /**
    * Return IsoString converted to utc
    * @param {*} date 
    */
   static toISOstringUTC(date) {
      return moment(date, format)
         .add(-moment().utcOffset(), "m")
         .toISOString();
   }

   static startOf(units, date) {
      return moment(date).startOf(units).toDate();
   }
   static endOf(units, date) {
      return moment(date).endOf(units).toDate();
   }

   static getGMTDate(dateString) {
      return new Date(dateString.replace(/-/g, '/') + " GMT");
	}
	
	static isDateString(str) {
		if (str.length >= 19) {
			return moment(str.substr(0, 19), "YYYY-MM-DDTHH:mm:ss", true).isValid();
		} else {
			return false;
		}
	}

	static add(units, date,amount){
		return moment(date).add(amount, units).toDate()
	}
}



// WEBPACK FOOTER //
// ./src/utils/dateTime.js